import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import './App.css';

// Import components
import Dashboard from './components/Dashboard';
import ProjectList from './components/ProjectList';
import ProjectForm from './components/ProjectForm';
import SiteVisitForm from './components/SiteVisitForm';
import AssessmentForm from './components/AssessmentForm';
import VisitDetails from './components/VisitDetails';

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar">
          <div className="nav-container">
            <h1 className="nav-logo">
              <Link to="/">GRIHA Site Visit System</Link>
            </h1>
            <ul className="nav-menu">
              <li className="nav-item">
                <Link to="/" className="nav-link">Dashboard</Link>
              </li>
              <li className="nav-item">
                <Link to="/projects" className="nav-link">Projects</Link>
              </li>
              <li className="nav-item">
                <Link to="/projects/new" className="nav-link">New Project</Link>
              </li>
            </ul>
          </div>
        </nav>

        <div className="main-content">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/projects" element={<ProjectList />} />
            <Route path="/projects/new" element={<ProjectForm />} />
            <Route path="/projects/:id/edit" element={<ProjectForm />} />
            <Route path="/projects/:projectId/visits/new" element={<SiteVisitForm />} />
            <Route path="/visits/:visitId" element={<VisitDetails />} />
            <Route path="/visits/:visitId/assess" element={<AssessmentForm />} />
            <Route path="/visits/:visitId/edit" element={<SiteVisitForm />} />
          </Routes>
        </div>

        <footer className="footer">
          <p>&copy; 2024 GRIHA Site Visit Report System. All rights reserved.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
